@if (visible) {
	<div class="change-box" [ngClass]="changeBoxCssClass()">{{ changedText() }}</div>
}
